import PropTypes from 'prop-types';
import { useState } from 'react';
import ActivationSuccessModal from 'ui-addon-upgrades/_core/common/components/activation/ActivationSuccessModal';
import { NEXT_STEPS_SURVEY_API_NAMES } from 'ui-addon-upgrades/_core/common/constants/trials';
import { upgradeDataPropsInterface } from 'ui-addon-upgrades/_core/common/data/upgradeData/interfaces/upgradeDataPropsInterface';
import { sourceKeys } from 'ui-addon-upgrades/_core/common/data/upgradeData/properties/sources';
import TrialActivationNextStepsModal from './TrialActivationNextStepsModal';
// @ts-expect-error dependency missing types
import UpgradeProductToApiNameMap from 'self-service-api/constants/UpgradeProductToApiNameMap';
import FeatureSurveyModal from './featureSurvey/FeatureSurveyModal';
import { useIsEligibleForFeatureSurvey } from './featureSurvey/useIsEligibleForFeatureSurvey';
import enviro from 'enviro';
import { jsx as _jsx } from "react/jsx-runtime";
const SUCCESS_MODAL_TYPES = {
  INITIAL_SUCCESS: 'INITIAL_SUCCESS',
  NEXT_STEPS_SURVEY: 'NEXT_STEPS_SURVEY',
  FEATURE_SURVEY: 'FEATURE_SURVEY'
};
const TrialActivationSuccessContainer = ({
  hideBackground,
  header,
  subText,
  ctaText,
  onSuccess,
  upgradeData,
  shouldHideSurvey,
  showIllustration,
  showTrialLoadingState
}) => {
  const {
    upgradeProduct,
    apiName
  } = upgradeData;
  const apiNameToUse = apiName || UpgradeProductToApiNameMap[upgradeProduct];
  const isEligibleForFeatureSurvey = useIsEligibleForFeatureSurvey(apiNameToUse);
  const shouldShowTrialFeatureSurvey = enviro.isProd() ? isEligibleForFeatureSurvey : window.location.search.includes('showFeatureSurvey');
  const initialModal = shouldShowTrialFeatureSurvey ? SUCCESS_MODAL_TYPES.FEATURE_SURVEY : SUCCESS_MODAL_TYPES.INITIAL_SUCCESS;
  const [successModalType, setSuccessModalType] = useState(initialModal);
  const maybeShowNextStepsSurvey = () => {
    const nextStepsIncludesProduct = NEXT_STEPS_SURVEY_API_NAMES.includes(apiNameToUse);
    const shouldShowNextStepsSurvey = nextStepsIncludesProduct && !shouldHideSurvey;
    if (shouldShowNextStepsSurvey) {
      setSuccessModalType(SUCCESS_MODAL_TYPES.NEXT_STEPS_SURVEY);
    } else if (onSuccess) {
      onSuccess();
    }
  };
  switch (successModalType) {
    case SUCCESS_MODAL_TYPES.NEXT_STEPS_SURVEY:
      return /*#__PURE__*/_jsx(TrialActivationNextStepsModal, {
        upgradeData: upgradeData
      });
    case SUCCESS_MODAL_TYPES.INITIAL_SUCCESS:
      return /*#__PURE__*/_jsx(ActivationSuccessModal, {
        type: sourceKeys.TRIAL,
        hideBackground: hideBackground,
        header: header,
        subText: subText,
        ctaText: ctaText,
        showIllustration: showIllustration,
        showTrialLoadingState: showTrialLoadingState,
        onSuccess: maybeShowNextStepsSurvey,
        upgradeData: upgradeData,
        shouldShowTrialFeatureSurvey: shouldShowTrialFeatureSurvey
      });
    case SUCCESS_MODAL_TYPES.FEATURE_SURVEY:
      return /*#__PURE__*/_jsx(FeatureSurveyModal, {
        apiName: apiNameToUse,
        setInitialSuccessModal: () => {
          setSuccessModalType(SUCCESS_MODAL_TYPES.INITIAL_SUCCESS);
        },
        upgradeData: upgradeData
      });
    default:
      return null;
  }
};
TrialActivationSuccessContainer.propTypes = Object.assign({
  hideBackground: PropTypes.bool.isRequired,
  header: PropTypes.node,
  subText: PropTypes.node,
  ctaText: PropTypes.node,
  showIllustration: PropTypes.bool,
  shouldHideSurvey: PropTypes.bool,
  onSuccess: PropTypes.func,
  showTrialLoadingState: PropTypes.bool
}, upgradeDataPropsInterface);
export default TrialActivationSuccessContainer;